import SortingModal from "./SortingModal";

export default SortingModal;
